import React, { useEffect } from "react";
import Router from "Router";
import NiceModal from "@ebay/nice-modal-react";
import { Provider } from "react-redux";
import store from "store";
import AddUserModal from "components/Users/AddUserModal";
import { getUserTypes } from "actions/users";
import AddAgentModal from "components/Agents/AddAgentModal";
import AddMediaModal from "components/Media/AddMediaModal";
import ChatSessionModal from "components/Chat/ChatSessionModal";
import AddWorkflowModal from "components/Workflows/AddWorkflowModal";
import AddNodeModal from "components/Workflows/AddNodeModal";
import TestNodeModal from "components/Workflows/TestNodeModal";
import TestWorkflowModal from "components/Workflows/TestWorkflowModal";
import AddFunctionModal from "components/Workflows/AddFunctionModal";
import AddFunctionToNodeModal from "components/Workflows/AddFunctionToNodeModal";
import NodePropertiesModal from "components/Workflows/NodePropertiesModal";
import ArchiveWorkflowModal from "components/Workflows/ArchiveWorkflowModal";
import AddSupportingContentModal from "components/SupportingContent/AddSupportingContentModal";
import { AppProvider } from "contexts/AppContext";
import { LiveEventsProvider } from "contexts/LiveEventsContext";
import { DataSetsProvider } from "contexts/DataSetsContext";


import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";

NiceModal.register("add-user", AddUserModal);
NiceModal.register("add-agent", AddAgentModal);
NiceModal.register("add-media", AddMediaModal);
NiceModal.register("add-workflow", AddWorkflowModal);
NiceModal.register("add-node", AddNodeModal);
NiceModal.register("test-node", TestNodeModal);
NiceModal.register("test-workflow", TestWorkflowModal);
NiceModal.register("add-function", AddFunctionModal);
NiceModal.register("add-function-to-node", AddFunctionToNodeModal);
NiceModal.register("chat-session", ChatSessionModal);
NiceModal.register("node-properties", NodePropertiesModal);
NiceModal.register("archive-workflow", ArchiveWorkflowModal);
NiceModal.register("add-supporting-content", AddSupportingContentModal);

const App = () => {
  useEffect(() => {
    store.dispatch(getUserTypes());
    // eslint-disable-next-line
  }, []);
  return (
    <Provider store={store}>
      <AppProvider>
        <DataSetsProvider>
          <LiveEventsProvider>
            <NiceModal.Provider>
              <Router />
            </NiceModal.Provider>
          </LiveEventsProvider>
        </DataSetsProvider>
      </AppProvider>
    </Provider>
  );
};
export default App;
